import React, { useState } from 'react';
import BottomNavigation from './components/BottomNavigation';
import HomePage from './pages/HomePage';
import VehiclePage from './pages/VehiclePage';
import StorePage from './pages/StorePage';
import MyPage from './pages/MyPage';
import { CartProvider } from './contexts/CartContext';

function App() {
  const [currentTab, setCurrentTab] = useState('home');

  const renderContent = () => {
    switch (currentTab) {
      case 'home':
        return <HomePage onTabChange={setCurrentTab} />;
      case 'vehicle':
        return <VehiclePage />;
      case 'store':
        return <StorePage />;
      case 'my':
        // return <div className="p-4 text-center">我的页面</div>;
        return <MyPage />;
      default:
        return <HomePage onTabChange={setCurrentTab} />;
    }
  };

  return (
    <CartProvider>
      <div className="min-h-screen bg-gray-50">
        <div className="pb-20">
          {renderContent()}
        </div>
        <BottomNavigation currentTab={currentTab} onTabChange={setCurrentTab} />
      </div>
    </CartProvider>
  );
}

export default App;
